
































































































































































































































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {CreatePatientVascularAccess, EditPatientVascularAccess} from "@/api/vascularAccess"
import photo from './picture.vue'
@Component({
	components: {photo}
})
export default class Patient extends AbpBase {
	@Prop() value: boolean
	@Prop() data: any
	modalShow = false
	form: any = {}
	modalData: any = ""
	url = XMLHTTP_BASEURL
	created() {
		if (this.data.mode === 'add') {
			this.form = {
				inputDate: new Date()
			}
		} else {
			this.form = this.data.item
		}
	}

	cancel() {
		(this.$refs.roleForm as any).resetFields();
		this.$emit('input', false)
	}
	modalShowFun(){
		this.modalData = this.form.remarks || ''
		this.modalShow = true
	}
	save() {
		(this.$refs.roleForm as any).validate(async (valid: boolean) => {
			if (valid) {
				let res
				this.form.inputDate = (this.form.inputDate as any).Format('yyyy-MM-dd')
				if (this.data.mode === 'add') {
					this.form.patientId = this.data.patient.id
					this.form.vaType = this.data.name
					res = await CreatePatientVascularAccess(this.form)
				} else {
					res = await EditPatientVascularAccess(this.form)
				}
				if (res.status === 1) {
					this.$emit('saveSuccess');
				}
			}
		})
	}
	saveSuccess(val:any){
		this.form.remarks = val
		this.modalShow = false
	}
	get modalTitle() {
		return (this.data.mode === 'add' ? '新增' : '编辑') + this.data.name + '通路'
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	roleRule = {
		inputDate: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('RoleName'))}],
		bodeSide: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('RoleName'))}],
		punctureDate: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('RoleName'))}],
		cylinderMethod: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('RoleName'))}],
		operationTypeOther: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('RoleName'))}],
		operationType: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('RoleName'))}],
		position: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('RoleName'))}],
		positionOther: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('RoleName'))}],
		hospital: [{
			required: true,
			message: this.L('FieldIsRequired', undefined, this.L('DisplayName')),
			trigger: 'blur'
		}]
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/road/addOrEdit.vue